export default "__VITE_ASSET__HxxOyc9___"